const KEYCODE_TAB = 9
const focusElements = ref([])
const firstFocusEl = ref()
const lastFocusEl = ref()

export function useFocusTrap(element: HTMLElement) {
    focusElements.value = Array.from(
        element.querySelectorAll(
            'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[tabindex]:not([tabindex="-1"]), p span[tabindex]:not([tabindex="-1"]), select:not([disabled])',
        ),
    )
    firstFocusEl.value = focusElements.value[0]
    lastFocusEl.value = focusElements.value[focusElements.value.length - 1]
    element.addEventListener('keydown', handleKeyDown)
}

function handleKeyDown(e) {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB

    if (!isTabPressed) {
        return
    }

    if (e.shiftKey) {
        if (document.activeElement === firstFocusEl.value) {
            lastFocusEl.value.focus()
            e.preventDefault()
        }
    } else {
        if (document.activeElement === lastFocusEl.value) {
            firstFocusEl.value.focus()
            e.preventDefault()
        }
    }
}
